export const icons = {
    'text': 'flicon-text',
    'number': 'flicon-number',
    'pointer': 'flicon-linked-field',
    'check': 'flicon-logical',
    'datetime': 'flicon-date',
    'formula': 'flicon-formula',
    'lookup': 'flicon-lookup',
    'phone': 'flicon-phone',
    'email': 'flicon-email',
    'url': 'flicon-url',
    'image': 'flicon-image',
    'textarea': 'flicon-longtext',
    'linkedfield': 'flicon-linked-field',
    'uid': 'flicon-lookup'
}

export const urlPatterns = [{
    name: 'facebook',
    subs: ['//facebook.com', '.facebook.com']
}, {
    name: 'instagram',
    subs: ['//instagram.com', '.instagram.com']
}, {
    name: 'linkedin',
    subs: ['//linkedin.com', '.linkedin.com']
}, {
    name: 'youtube',
    subs: ['//youtube.com', '.youtube.com', '//youtu.be', '.youtu.be']
}, {
    name: 'pinterest',
    subs: ['//pinterest.', '.pinterest.']
}, {
    name: 'email',
    subs: ['mailto:']
}]
